export function goFullscreen(element: HTMLDivElement) {
  if (document.fullscreenElement) {
    return Promise.reject(new Error('全屏模式被禁用'));
  }
  let result = null;
  if (element.requestFullscreen) {
    result = element.requestFullscreen();
  }
  return result || Promise.reject(new Error('不支持全屏'));
}
export function cancelFullscreen() {
  document.exitFullscreen?.();
}

// 精确显示小数后2位
export const keepTwoDecimalWithReg = (num?: number | null) => {
  if (typeof num === 'number') {
    if (num > 0) {
      return Math.floor(num * 100) / 100;
    }
    let val = Math.ceil(num * 100) / 100;
    if (val === -0) return 0;
    return val;
  }
  return num;
};
// 精确显示小数点后2位，没有时补0
export const keepTwoDecimalStr = (num: number) => {
  const result = Number(num.toString().match(/^\d+(?:\.\d{0,2})?/));
  let s = result.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
};

// 获取树深度
export const getDepth = (obj: any) => {
  var depth = 0;
  if (obj.children) {
    obj.children.forEach(function (d: any) {
      var tmpDepth = getDepth(d);
      if (tmpDepth > depth) {
        depth = tmpDepth;
      }
    });
  }
  return 1 + depth;
};

// format选项格式
export const formatLevelOptions = (maxDepth: number, disabledNum: number) => {
  const res = [];
  for (let i = 1; i < maxDepth + 1; i++) {
    let disabled = false;
    if (i <= disabledNum) {
      disabled = true;
    }
    res.push({
      label: `${i}级`,
      value: i,
      disabled,
    });
  }
  return res;
};

export const pollingInterval = 1000 * 60 * 15; //轮询一次
